const strings = {
  de: {
    appTitle: 'Frag die Bibel',
    translation: 'Übersetzung',
    loadingTranslations: 'Übersetzungen werden geladen...',
    selectTranslation: '— Übersetzung wählen —',
    book: 'Buch',
    oldTestament: 'Altes Testament',
    newTestament: 'Neues Testament',
    loadingBooks: 'Bücher werden geladen...',
    chapter: 'Kapitel',
    verse: 'Vers',
    verseAvailable: 'verfügbar',
    loadingBook: 'wird geladen...',
    present: 'Präsentieren',
    backgroundImage: 'Hintergrundbild',
    remove: 'Entfernen',
    exitEsc: 'Beenden (ESC)',
  },
  en: {
    appTitle: 'Ask the Bible',
    translation: 'Translation',
    loadingTranslations: 'Loading translations...',
    selectTranslation: '— Select a translation —',
    book: 'Book',
    oldTestament: 'Old Testament',
    newTestament: 'New Testament',
    loadingBooks: 'Loading books...',
    chapter: 'Chapter',
    verse: 'Verse',
    verseAvailable: 'available',
    loadingBook: 'Loading...',
    present: 'Present',
    backgroundImage: 'Background Image',
    remove: 'Remove',
    exitEsc: 'Exit (ESC)',
  },
  fr: {
    appTitle: 'Interroge la Bible',
    translation: 'Traduction',
    loadingTranslations: 'Chargement des traductions...',
    selectTranslation: '— Choisir une traduction —',
    book: 'Livre',
    oldTestament: 'Ancien Testament',
    newTestament: 'Nouveau Testament',
    loadingBooks: 'Chargement des livres...',
    chapter: 'Chapitre',
    verse: 'Verset',
    verseAvailable: 'disponibles',
    loadingBook: 'Chargement...',
    present: 'Présenter',
    backgroundImage: 'Image de fond',
    remove: 'Supprimer',
    exitEsc: 'Quitter (ESC)',
  },
  ru: {
    appTitle: 'Спроси Библию',
    translation: 'Перевод',
    loadingTranslations: 'Загрузка переводов...',
    selectTranslation: '— Выберите перевод —',
    book: 'Книга',
    oldTestament: 'Ветхий Завет',
    newTestament: 'Новый Завет',
    loadingBooks: 'Загрузка книг...',
    chapter: 'Глава',
    verse: 'Стих',
    verseAvailable: 'доступно',
    loadingBook: 'Загрузка...',
    present: 'Презентация',
    backgroundImage: 'Фоновое изображение',
    remove: 'Удалить',
    exitEsc: 'Выход (ESC)',
  },
};

export type I18n = typeof strings['de'];

type Lang = keyof typeof strings;

export function getI18n(lang: string): I18n {
  return strings[lang as Lang] ?? strings.de;
}